import { IGraphQl } from 'client/graphQueries/IGraphQl'
import { DraftCommonInterface } from 'client/Interfaces/Draft/v1/DraftInterface'
import { IInvoiceEventShared } from 'client/Interfaces/Invoice/InvoiceEventsInterface'

export enum ReceiptType {
  draft = 'receiptDraft',
  approved = 'receipt',
}

export enum ReceiptStatus {
  DRAFT = 'draft',
  CREATED = 'created',
  SENT = 'sent',
  DELETED = 'deleted',
}

export interface ReceiptDraftInterface extends DraftCommonInterface {
  id: number
  receiptNumber?: string
  documentType?: ReceiptType.draft | ReceiptType.approved
}

export interface ReceiptInterface extends ReceiptDraftInterface {
  revisionId: number
  receiptNumber: string
  documentType: ReceiptType.approved
  status: { status: ReceiptStatus; events: IInvoiceEventShared[] }
}

export type ReceiptListItemInterface = IGraphQl<ReceiptInterface, ReceiptType.approved>

export type ReceiptDraftListItemInterface = IGraphQl<ReceiptDraftInterface, ReceiptType.draft>
